import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import VerseOfTheDay from "@/components/VerseOfTheDay";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#FDFBF7]">
      <Navigation />
      <main className="flex-1 pt-[68px]">
        <VerseOfTheDay />
        {children}
      </main>
      <Footer />
    </div>
  );
}
